<template>
  <div id="app">
	<a-config-provider :locale="zhCN">
      <router-view />
	</a-config-provider>
  </div>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  name: 'App',
  components: {
  },
  data(){
    return{
		zhCN
    }
  },
  methods:{
  },

  mounted() {
  },
}
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
</style>
